import {
  Layers,
  Wrench,
  Leaf,
  Ruler,
  SlidersHorizontal,
  Headphones,
} from "lucide-react";
import { why } from "../data/siteContent";
import useReveal from "../hooks/useReveal";

const iconMap = {
  Layers,
  Wrench,
  Leaf,
  Ruler,
  SlidersHorizontal,
  Headphones,
};

function WhyCard({ item, index }) {
  const ref = useReveal();
  const Icon = iconMap[item.icon] || Layers;
  return (
    <div
      ref={ref}
      data-testid={`why-item-${index}`}
      className="reveal group p-8 md:p-10 bg-white border border-brand-greyBorder hover:border-brand-red transition-colors"
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="w-12 h-12 flex items-center justify-center mb-6 border border-brand-red text-brand-red group-hover:bg-brand-red group-hover:text-white transition-colors">
        <Icon size={22} strokeWidth={1.6} />
      </div>
      <h3 className="font-serif text-2xl text-brand-charcoal mb-3">
        {item.title}
      </h3>
      <p className="text-sm text-neutral-600 leading-relaxed">{item.text}</p>
    </div>
  );
}

export default function WhyAlumak() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-24 md:py-32 bg-brand-grey"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.35em] uppercase text-brand-red mb-5 font-medium">
              <span className="inline-block w-10 h-px bg-brand-red align-middle mr-4" />
              {why.eyebrow}
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-brand-charcoal leading-[1.1] tracking-tight">
              {why.title}
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-10">
            <p className="text-base md:text-lg text-neutral-700 leading-relaxed">
              {why.description}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {why.items.map((item, i) => (
            <WhyCard key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
